import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ddpsAPI } from '../services/api';
import Button from '../components/Button';

const ChefZoneDDPDashboard = () => {
  const { t } = useTranslation();
  const [ddps, setDdps] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    ddpsAPI.getAll()
      .then(res => setDdps(res.ddps))
      .finally(() => setLoading(false));
  }, []);

  const handleStatus = async (id, status, infoRequested) => {
    setLoading(true);
    await ddpsAPI.updateStatus(id, { status, infoRequested });
    ddpsAPI.getAll().then(res => setDdps(res.ddps)).finally(() => setLoading(false));
  };

  return (
    <div className="max-w-3xl mx-auto mt-8">
      <h2 className="text-xl font-bold mb-4">{t('ddp.dashboardTitle')}</h2>
      {loading ? <div>{t('common.loading')}</div> : (
        <table className="w-full border">
          <thead>
            <tr>
              <th>{t('ddp.navire')}</th>
              <th>{t('ddp.arrivingDate')}</th>
              <th>{t('ddp.transactionType')}</th>
              <th>{t('ddp.products')}</th>
              <th>{t('ddp.derivedTotalWeight')}</th>
              <th>{t('ddp.manutentionNumber')}</th>
              <th>{t('ddp.status')}</th>
              <th>{t('common.actions')}</th>
            </tr>
          </thead>
          <tbody>
            {ddps.map(ddp => (
              <tr key={ddp.id}>
                <td>{ddp.navire}</td>
                <td>{ddp.arrivingDate}</td>
                <td>{ddp.transactionType ? t(`loads.transactionTypes.${String(ddp.transactionType).toLowerCase()}`) : '—'}</td>
                <td>{ddp.productsSummary || '—'}</td>
                <td>{Number(ddp.totalWeight || 0).toLocaleString('fr-FR')} t</td>
                <td>{ddp.manutentionNumber}</td>
                <td>{ddp.status}</td>
                <td>
                  <Button onClick={() => handleStatus(ddp.id, 'accepted')}>{t('ddp.accept')}</Button>
                  <Button onClick={() => handleStatus(ddp.id, 'denied')}>{t('ddp.deny')}</Button>
                  <Button onClick={() => handleStatus(ddp.id, 'info_requested', prompt(t('ddp.requestInfo')))}>{t('ddp.requestInfo')}</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ChefZoneDDPDashboard;
